import { VStack } from "@chakra-ui/react";

import { ContactImportCard } from "@components/Cards/ContactImportCard";
import { ContactToImport } from "@components/Import/types";

interface ContactsImportListProps {
    contacts: ContactToImport[];
    bgColor: string;
}

export const ContactsImportList = (props: ContactsImportListProps) => {
    const { contacts, bgColor } = props;

    return (
        <VStack
            spacing={2}
            align="stretch"
            overflowY="auto"
            flex="1"
            minH={0}
            sx={{
                "&::-webkit-scrollbar": { width: "8px" },
                "&::-webkit-scrollbar-track": { background: "transparent" },
                "&::-webkit-scrollbar-thumb": { background: "var(--chakra-colors-gray-600)", borderRadius: "8px" },
            }}
        >
            {contacts.map((contact, idx) => (
                <ContactImportCard key={idx} contact={contact} bgColor={bgColor} />
            ))}
        </VStack>
    );
}